import { LEGAL_DOCUMENT_PATHS } from '@provision/landing-page-utils';
import { useLegalDocumentSegmentToken } from 'src/graphql/entities/legal-document/use-legal-document-segment-token';
import type { LiveLinkState } from 'src/pages/Settings/memberships/components/live-link';
import type { LegalDocumentSurface } from 'src/pages/Settings/memberships/hooks/use-legal-document-surface';
import {
  IDLE_LOOKUP,
  useLiveLinkState,
} from 'src/pages/Settings/memberships/hooks/use-live-link-state';
import { useSegmentBaseUrl } from 'src/pages/Settings/memberships/hooks/use-segment-base-url';

/**
 * Not live until the document is saved. Always carries the segment token, so a link still shows
 * this segment's document if its address later serves other segments too.
 */
export const useLegalDocumentLiveLink = (
  partnerId: number | null,
  brandId: string | undefined,
  surface: LegalDocumentSurface | null,
): LiveLinkState => {
  const activePartnerId = surface ? partnerId : null;
  const baseUrl = useSegmentBaseUrl(activePartnerId, brandId);
  const token = useLegalDocumentSegmentToken(activePartnerId, brandId);

  let url: string | undefined;
  if (baseUrl.url && surface?.savedDocument) {
    const path = `${baseUrl.url}${LEGAL_DOCUMENT_PATHS[surface.kind]}`;
    url = token ? `${path}?segment=${token}` : path;
  }

  return useLiveLinkState(url, baseUrl, surface?.documentsLookup ?? IDLE_LOOKUP);
};
